import Svg, { Path } from 'react-native-svg'
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const Logout = ({ width = 24, height = 24, color = '#000' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <Path
      fill={color}
      d="M17.87 3.91a1 1 0 0 0-1.58.966 1 1 0 0 0 .4.654 8 8 0 1 1-9.38 0 1.002 1.002 0 0 0-1.18-1.62 10 10 0 1 0 11.74 0ZM12 8a1 1 0 0 0 1-1V3a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1Z"
    />
  </Svg>
)
export default Logout
